import HttpService from "./HttpService";

let loginService = {
  
  async logout() {
    try {
      await HttpService.bffApi.post(`/logout`, null, { withCredentials:true});
    } catch (err) {
      console.log(err )
    } finally {
      const loginOpts = await this.loginOpts();
      window.location.href = loginOpts.data.loginUri;
    }
  },

  loginOpts() {
    return HttpService.bffApi.get(`/login-options`, null);
  }
};

export default loginService;
